import { auth } from '../shared/firebase-config';
import { User } from 'firebase/auth';

/**
 * Check if current user has admin custom claim
 */
export async function checkAdminClaim(): Promise<boolean> {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    return false;
  }

  try {
    // Force token refresh to get latest claims
    const token = await currentUser.getIdToken(true);
    const decodedToken = await auth.currentUser?.getIdTokenResult();
    
    if (decodedToken && decodedToken.claims.admin === true) {
      return true;
    }
    
    return false;
  } catch (error) {
    console.error('[AuthService] Error checking admin claim:', error);
    return false;
  }
}

/**
 * Get current user
 */
export function getCurrentUser(): User | null {
  return auth.currentUser;
}

/**
 * Sign out current user
 */
export async function signOut(): Promise<void> {
  await auth.signOut();
}
